export function generateStatus(id) {
    var status;

    switch (id) {
        case 1:
            status = "New";
            break;
        case 3:
            status = "Ready to collect";
            break; 
        case 5:
            status = "Complete";
            break;
        case 12:
            status = "Processing";
            break;
        case 13:
            status = "Complete";
            break;
        default:
            status = "Reject";
    }
    return status;
}